<template>
  <div class="iv-contact">
    <div class="iv-contact-header iv-p-t-40 iv-pos-r">
      <h1 class="iv-fs-40 iv-m-b-12">党员联系员工</h1>
      <p class="iv-contact-header-desc">党员联系员工机制是发挥基层党组织战斗堡垒作用和党员先锋模范作用的重要工作范式。各级党组织通过建立党员结对子联系员工机制，开展党员“一对多联系、一对一沟通”，与员工紧密相连，当好主心骨。</p>
      <div class="iv-contact-header-icon iv-m-t-36">
        <dl v-for="(item, index) in types" :key="index">
          <dt class="iv-text-center"><IconFont :type="item.icon" class="iv-fs-36"></IconFont></dt>
          <dd class="iv-text-center iv-m-t-8 iv-fs-14">{{item.title}}</dd>
        </dl>
      </div>
      <p class="iv-contact-header-entry iv-pos-a iv-pointer" @click="toDetailPage('twinPage')">
        <IconFont type="xiangmu" class="iv-fs-24 iv-m-r-8"></IconFont>
        <span class="iv-fc-85">结对子员工</span>
      </p>
    </div>
    <div class="iv-main-width iv-m-t-24 iv-p-40">
      <ul class="iv-contact-content">
        <li v-for="(item, index) in types" :key="index" class="iv-m-b-24 iv-pointer">
          <p class="iv-fs-16">
            <span class="iv-fc-45 iv-m-r-8">[某某某党委]</span>
            <span class="iv-fc-85 iv-hover-color" @click="toDetailPage('contactDetail')">xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</span>
          </p>
          <span class="iv-fs-14 iv-fc-45">2021-09-09</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import column from './column'
import pastColumn from './pase-column'
import IconFont from '@/components/iconfont'
import DragTable from '@/components/drag-table-inline'
import FooterOperator from '@/components/footer-operator'
import LayoutTitle from '@/components/layout/layout-title'

export default {
  data () {
    return {
      contactData: []
    }
  },
  created () {
    this.init()
    this.column = column.call(this)
    this.pastColumn = pastColumn.call(this)
  },
  methods: {
    //新增联系记录
    addContactRecord () {},
    //结对子页面
    toDetailPage (name) {
      this.$router.push({
        name: name
      })
    },
    back () {
      this.$router.push({
        name: 'index'
      })
    },
    init () {
      this.types = [{
        icon: 'xiangmu',
        title: 'CCO组织专职人员与支部结对子'
      }, {
        icon: 'xiangmu',
        title: '党支部组织落实党员与员工结对子'
      }, {
        icon: 'xiangmu',
        title: '党员结对子联系员工主要任务责任'
      }]
    }
  },
  components: {
    IconFont,
    DragTable,
    LayoutTitle,
    FooterOperator
  }
}
</script>

<style lang="scss" scoped>
.iv-contact {
  min-height: 100%;
  .iv-contact-header {
    width: 100%;
    height: 370px;
    padding-left: 8.3%;
    background: url('~@/assets/images/index/contact.png') no-repeat center center;
    background-size: 100% 100%;
    color: #FF6E2E;
    .iv-contact-header-desc {
      width: 535px;
    }
    .iv-contact-header-icon {
      display: flex;
      align-items: center;
      dl {
        width: 120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 84px;
        dt {
          width: 56px;
          height: 56px;
          border: 1px solid #FF6E2E;
          border-radius: 50%;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .iv-contact-header-entry {
      display: flex;
      align-items: center;
      background-color: #fff;
      right: 0;
      top: 36px;
      border-top-left-radius: 24px;
      border-bottom-left-radius: 24px;
      padding: 4px 16px;
    }
  }
  .iv-main-width {
    background-color: #fff;
    border-radius: 4px;
  }
  .iv-contact-content {
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .iv-fs-40 {
    font-size: 40px;
  }
  .iv-fs-36 {
    font-size: 36px;
  }
}
</style>
